export const routePermissions = [
  2201, 1701, 1800, 2201, 1300, 1900, 1000, 1101, 1100, 1301, 1100, 1101, 1101, 1102, 1100, 1001, 1001, 1200, 1201,
  1201, 1201, 1201, 2000, 1401, 1301, 2900, 1800, 1800, 1800, 3300, 1001, 1800, 3900, 1600, 1601, 1602, 1603, 1604,
  1800, 1609, 1611, 1526
];
